import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { extractErrorMessage } from "@/api/axios";

export function useApiErrorMessage() {
  const { t } = useTranslation();
  return useCallback(
    (err: unknown) => extractErrorMessage(err, t("common.unknownError")),
    [t],
  );
}
